(function () {
    // Esperar a que el DOM esté completamente cargado
    function initVideoScript() {
        const video = document.getElementById('mainVideo');
        const buttons = document.querySelectorAll('.timed-button');
        const lines = document.querySelectorAll('.line');
        const messageBox = document.getElementById('message');

        // Verificar que todos los elementos existen
        if (!video) {
            return;
        }

        if (buttons.length === 0) {
            return;
        }

        // Array para rastrear qué botones ya se mostraron
        const shownButtons = new Set();
        let isFirstPlay = true;
        let allButtonsShown = false;

        // Escuchar el evento de tiempo del video
        video.addEventListener('timeupdate', function () {
            // Solo mostrar botones en la primera reproducción
            if (!isFirstPlay) return;

            const currentTime = Math.floor(video.currentTime);

            // Verificar cada botón
            buttons.forEach(button => {
                const showTime = parseInt(button.getAttribute('data-time'));
                const buttonId = button.getAttribute('data-time');
                //console.log('Viendo sección:', section, section.classList);

                // Mostrar botón solo si no se ha mostrado antes
                if (currentTime >= showTime && currentTime < showTime + 5 && !shownButtons.has(buttonId)) {
                    button.classList.add('show');
                    shownButtons.add(buttonId);

                    // Verificar si ya se mostraron todos los botones
                    if (shownButtons.size === buttons.length && !allButtonsShown) {
                        allButtonsShown = true;
                        // Mostrar todas las líneas
                        lines.forEach(line => {
                            line.classList.add('visible');
                        });
                    }
                }
            });
        });

        // Detectar cuando el video vuelve al inicio (loop)
        video.addEventListener('seeking', function () {
            if (video.currentTime < 1) {
                isFirstPlay = false;
            }
        });

        // Manejar clicks en los botones
        window.handleButtonClick = function (buttonNumber) {
            const messages = {
                1: '🎉 ¡Oferta Especial activada! Descuento del 50%',
                2: '📖 Descargando más información...',
                3: '✅ ¡Gracias por suscribirte! Te enviaremos novedades.',
                4: '📥 Tu descarga comenzará en breve...'
            };

            if (messageBox) {
                messageBox.textContent = messages[buttonNumber];
                messageBox.classList.add('show');

                // Ocultar mensaje después de 3 segundos
                setTimeout(() => {
                    messageBox.classList.remove('show');
                }, 3000);
            }

            console.log(`Botón ${buttonNumber} clickeado en el segundo ${Math.floor(video.currentTime)}`);
        };
    }

    // Ejecutar cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoScript);
    } else {
        // El DOM ya está listo
        initVideoScript();
    }
})();